// @flow

import type {StatelessFunctionalComponent} from 'react';

import {
  Button,
  Dialog,
  DialogBody,
  Flex,
  HeadlineLarge,
  ParagraphMedium,
  ParagraphMediumBold,
} from '@travel-frontend/ui-components';

import {Content} from 'components/PaypalOverlay/components/DialogContent';

export type Props = {
  title: string,
  subTitle: string,
  content: string,
  imgSrc: string,
  buttonLabel: string,
  open: boolean,
  onClose: () => void,
};

export const PaypalOverlay: StatelessFunctionalComponent<Props> = ({
  title,
  subTitle,
  content,
  buttonLabel,
  imgSrc,
  open,
  onClose,
}) => (
  <Dialog open={open} flexible>
    <DialogBody>
      <Content gap="24px" alignItems="center" padding="22px 4px">
        <img src={imgSrc} alt="" />
        <Flex gap="16px" alignItems="center">
          <HeadlineLarge>{title}</HeadlineLarge>
          <>
            <ParagraphMediumBold color="contentSecondary">
              {subTitle}
            </ParagraphMediumBold>
            <ParagraphMedium color="contentSecondary">
              {content}
            </ParagraphMedium>
          </>
        </Flex>
        <Button fullWidth variant="info" onClick={onClose}>
          {buttonLabel}
        </Button>
      </Content>
    </DialogBody>
  </Dialog>
);
